import request from '@/utils/request'
export default {
	// 正在直播的列表
	anchorMonitorList (params) {
		return request.post(`api/anchor/broadcasting-list`, params)
	}
}